// @ts-strict-ignore
import invariant from 'invariant';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { TabContext } from 'containers/TabContext';
import { AddAdminModalContainerLoadable } from 'modals/AddAdmin';
import { AddEditIntegrationModalContainerLoadable } from 'modals/AddEditIntegration';
import { AddEditWorkHistoryJobModalContainerLoadable } from 'modals/AddEditWorkHistoryJob';
import { AddOrEditImageModalContainerLoadable } from 'modals/AddOrEditImage';
import { AdminRequestModalContainerLoadable } from 'modals/AdminRequest';
import { ApproveItemModalContainerLoadable } from 'modals/ApproveItem';
import { AutoPublishIntegrationModalContainerLoadable } from 'modals/AutoPublishIntegration';
import { CancelCreditsModalContainerLoadable } from 'modals/CancelCredits';
import { ConfirmMergeOrgModalLoadable } from 'modals/ConfirmMergeOrg';
import { ConfirmationModalContainerLoadable } from 'modals/Confirmation';
import { ContactRecommendedCandidateModalLoadable } from 'modals/ContactRecommendedCandidate';
import { CreateSupportCaseModalContainerLoadable } from 'modals/CreateSupportCase';
import { DeferQueueItemModalContainerLoadable } from 'modals/DeferQueueItem';
import { DeleteAccountModalContainerLoadable } from 'modals/DeleteAccount';
import { DeleteCategoryModalContainerLoadable } from 'modals/DeleteCategory';
import { DeleteContentModalContainerLoadable } from 'modals/DeleteContent';
import { DeleteEmailPromoModalContainerLoadable } from 'modals/DeleteEmailPromo';
import { DeleteHeroSearchModalContainerLoadable } from 'modals/DeleteHeroSearch';
import { DeleteIntegrationModalContainerLoadable } from 'modals/DeleteIntegration';
import { DeleteJobFamilyModalContainerLoadable } from 'modals/DeleteJobFamily';
import { DeleteJobSynonymModalContainerLoadable } from 'modals/DeleteJobSynonym';
import { DeleteJobTitleModalContainerLoadable } from 'modals/DeleteJobTitle';
import { DeleteLandingPageLocationModalContainerLoadable } from 'modals/DeleteLandingPageLocation';
import { DeleteListingModalContainerLoadable } from 'modals/DeleteListing';
import { DeleteLocationGroupModalContainerLoadable } from 'modals/DeleteLocationGroup';
import { DeleteOrgModalContainerLoadable } from 'modals/DeleteOrg';
import { DeleteScheduledContentModalContainerLoadable } from 'modals/DeleteScheduledContent';
import { DeleteSubsiteModalContainerLoadable } from 'modals/DeleteSubsite';
import { DeleteWorkHistoryJobModalContainerLoadable } from 'modals/DeleteWorkHistoryJob';
import { DuplicateContentModalContainerLoadable } from 'modals/DuplicateContent';
import EmailSignupModalContainerLoadable from 'modals/EmailSignupModalContainerLoadable';
import FinishOauthSignupModalContainerLoadable from 'modals/FinishOauthSignupModalContainerLoadable';
import FlagListingModalContainerLoadable from 'modals/FlagListingModalContainerLoadable';
import ForgotPasswordModalContainerLoadable from 'modals/ForgotPasswordModalContainerLoadable';
import FreezeListingModalContainerLoadable from 'modals/FreezeListingModalContainerLoadable';
import GenericUncloseableModalLoadable from 'modals/GenericUncloseableModalLoadable';
import GradFairRegisterModalContainerLoadable from 'modals/GradFairRegisterModalContainerLoadable';
import GradFairsInformationRequiredModalContainerLoadable from 'modals/GradFairsInformationRequiredModalContainerLoadable';
import GradFairsShareContactModalLoadable from 'modals/GradFairsShareContactModalLoadable';
import GradProgramContactModalContainerLoadable from 'modals/GradProgramContactModalContainerLoadable';
import GradProgramContactSeeMoreInfoModal from 'modals/GradProgramContactSeeMoreInfoModal';
import HideRepostedListingsModalContainerLoadable from 'modals/HideRepostedListingsModalContainerLoadable';
import InformationRequiredModalContainerLoadable from 'modals/InformationRequiredModalContainerLoadable';
import LeadsNotificationPreferencesModalContainerLoadable from 'modals/LeadsNotificationPreferencesModalContainerLoadable';
import LoginModalContainerLoadable from 'modals/LoginModalContainerLoadable';
import MarkAsSpamModalContainerLoadable from 'modals/MarkAsSpamModalContainerLoadable';
import MediaGalleryModalContainerLoadable from 'modals/MediaGallery/MediaGalleryModalContainerLoadable';
import NotificationPreferencesModalContainerLoadable from 'modals/NotificationPreferencesModalContainerLoadable';
import { OrgUserPreferencesModalLoadable } from 'modals/OrgUserPreferences';
import PreviewScheduledContentModalContainerLoadable from 'modals/PreviewScheduledContentModalContainerLoadable';
import RefundPaymentModalContainerLoadable from 'modals/RefundPaymentModalContainerLoadable';
import RejectItemModalContainerLoadable from 'modals/RejectItemModalContainerLoadable';
import RemovePaymentMethodModalContainerLoadable from 'modals/RemovePaymentMethodModalContainerLoadable';
import SaveListingModalContainerLoadable from 'modals/SaveListingModalContainerLoadable';
import SelectContentBlockModalContainerLoadable from 'modals/SelectContentBlockModalContainerLoadable';
import ShareListingModalContainerLoadable from 'modals/ShareListingModalContainerLoadable';
import ShareNewListingModalLoadable from 'modals/ShareNewListingModalLoadable';
import SignupModalContainerLoadable from 'modals/SignupModalContainerLoadable';
import StaffChangePasswordModalContainerLoadable from 'modals/StaffChangePasswordModalContainerLoadable';
import StaffDeleteOrgModalContainerLoadable from 'modals/StaffDeleteOrgModalContainerLoadable';
import StaffGradFairAddToWaitlistModalContainerLoadable from 'modals/StaffGradFairAddToWaitlistModalContainerLoadable';
import StaffGradFairCancelRegistrationModalContainerLoadable from 'modals/StaffGradFairCancelRegistrationModalContainerLoadable';
import StaffGradFairInviteModalContainerLoadable from 'modals/StaffGradFairInviteModalContainerLoadable';
import StaffGradFairRegisterModalContainerLoadable from 'modals/StaffGradFairRegisterModalContainerLoadable';
import StaffGradFairRegistrationSponsorOrHostModalContainerLoadable from 'modals/StaffGradFairRegistrationSponsorOrHostModalContainerLoadable';
import StaffGradFairRemoveFromWaitlistModalContainerLoadable from 'modals/StaffGradFairRemoveFromWaitlistModalContainerLoadable';
import StaffLoginAsModalContainerLoadable from 'modals/StaffLoginAsModalContainerLoadable';
import TitleDescriptionModalContainerLoadable from 'modals/TitleDescriptionModalContainerLoadable';
import VatNumberModalContainerLoadable from 'modals/VatNumberModalContainerLoadable';
import VerifyEmailModalContainerLoadable from 'modals/VerifyEmailModalContainerLoadable';
import VoidLineItemModalContainerLoadable from 'modals/VoidLineItemModalContainerLoadable';
import { MainStoreState } from 'store/main';
import { setError } from 'store/main/ducks/error';
import { log } from 'utils/logging';
import waitForElement from 'utils/waitForElement';

import { ModalType } from './types/modal.types';

// @ts-expect-error ts-migrate(2739) FIXME: Type '{ SHARE_NEW_LISTING: any; SHARE_LISTING: any... Remove this comment to see the full error message
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const MODAL_COMPONENTS: Record<ModalType, Record<string, any>> = {
  SHARE_NEW_LISTING: ShareNewListingModalLoadable,
  SHARE_LISTING: ShareListingModalContainerLoadable,
  SAVE_LISTING: SaveListingModalContainerLoadable,
  FLAG_LISTING: FlagListingModalContainerLoadable,
  EMAIL_SIGNUP: EmailSignupModalContainerLoadable,
  VERIFY_EMAIL: VerifyEmailModalContainerLoadable,
  INFORMATION_REQUIRED: InformationRequiredModalContainerLoadable,
  ADMIN_REQUEST: AdminRequestModalContainerLoadable,
  LEADS_NOTIFICATION_PREFERENCES:
    LeadsNotificationPreferencesModalContainerLoadable,
  NOTIFICATION_PREFERENCES: NotificationPreferencesModalContainerLoadable,
  LOGIN: LoginModalContainerLoadable,
  SIGNUP: SignupModalContainerLoadable,
  FORGOT_PASSWORD: ForgotPasswordModalContainerLoadable,
  DELETE_ACCOUNT: DeleteAccountModalContainerLoadable,
  REMOVE_PAYMENT_METHOD: RemovePaymentMethodModalContainerLoadable,
  DELETE_LISTING: DeleteListingModalContainerLoadable,
  DELETE_ORG: DeleteOrgModalContainerLoadable,
  ADD_ADMIN: AddAdminModalContainerLoadable,
  CONFIRMATION: ConfirmationModalContainerLoadable,
  ADD_OR_EDIT_IMAGE: AddOrEditImageModalContainerLoadable,
  MEDIA_GALLERY: MediaGalleryModalContainerLoadable,
  VAT_NUMBER: VatNumberModalContainerLoadable,
  HIDE_REPOSTED_LISTINGS: HideRepostedListingsModalContainerLoadable,
  GRAD_FAIR_REGISTER: GradFairRegisterModalContainerLoadable,
  SELECT_CONTENT_BLOCK: SelectContentBlockModalContainerLoadable,
  DELETE_CONTENT: DeleteContentModalContainerLoadable,
  DELETE_SCHEDULED_CONTENT: DeleteScheduledContentModalContainerLoadable,
  PREVIEW_SCHEDULED_CONTENT: PreviewScheduledContentModalContainerLoadable,
  DEFER_QUEUE_ITEM: DeferQueueItemModalContainerLoadable,
  REJECT_ITEM: RejectItemModalContainerLoadable,
  APPROVE_ITEM: ApproveItemModalContainerLoadable,
  MARK_AS_SPAM: MarkAsSpamModalContainerLoadable,
  FREEZE_LISTING: FreezeListingModalContainerLoadable,
  CREATE_SUPPORT_CASE: CreateSupportCaseModalContainerLoadable,
  CONTACT_RECOMMENDED_CANDIDATE: ContactRecommendedCandidateModalLoadable,
  STAFF_DELETE_ORG: StaffDeleteOrgModalContainerLoadable,
  STAFF_CHANGE_PASSWORD: StaffChangePasswordModalContainerLoadable,
  CONFIRM_MERGE_ORG: ConfirmMergeOrgModalLoadable,
  DELETE_CATEGORY: DeleteCategoryModalContainerLoadable,
  DELETE_SUBSITE: DeleteSubsiteModalContainerLoadable,
  GRAD_PROGRAM_CONTACT: GradProgramContactModalContainerLoadable,
  REFUND_PAYMENT_MODAL: RefundPaymentModalContainerLoadable,
  VOID_LINE_ITEM: VoidLineItemModalContainerLoadable,
  CANCEL_CREDITS: CancelCreditsModalContainerLoadable,
  STAFF_GRAD_FAIR_REGISTER: StaffGradFairRegisterModalContainerLoadable,
  STAFF_GRAD_FAIR_CANCEL_REGISTRATION:
    StaffGradFairCancelRegistrationModalContainerLoadable,
  STAFF_GRAD_FAIR_SPONSOR_OR_HOST:
    StaffGradFairRegistrationSponsorOrHostModalContainerLoadable,
  STAFF_GRAD_FAIR_ADD_TO_WAITLIST:
    StaffGradFairAddToWaitlistModalContainerLoadable,
  STAFF_GRAD_FAIR_INVITE: StaffGradFairInviteModalContainerLoadable,
  STAFF_DELETE_EMAIL_PROMO: DeleteEmailPromoModalContainerLoadable,
  GRAD_FAIRS_SHARE_CONTACT: GradFairsShareContactModalLoadable,
  GRAD_FAIRS_INFORMATION_REQUIRED:
    GradFairsInformationRequiredModalContainerLoadable,
  GENERIC_UNCLOSEABLE: GenericUncloseableModalLoadable,
  DELETE_HERO_SEARCH: DeleteHeroSearchModalContainerLoadable,
  DELETE_JOB_FAMILY: DeleteJobFamilyModalContainerLoadable,
  DELETE_JOB_TITLE: DeleteJobTitleModalContainerLoadable,
  DELETE_JOB_SYNONYM: DeleteJobSynonymModalContainerLoadable,
  GRAD_PROGRAM_CONTACT_SEE_MORE_INFO: GradProgramContactSeeMoreInfoModal,
  STAFF_GRAD_FAIR_REMOVE_FROM_WAITLIST:
    StaffGradFairRemoveFromWaitlistModalContainerLoadable,
  STAFF_LOGIN_AS_USER: StaffLoginAsModalContainerLoadable,
  FINISH_OAUTH_SIGNUP: FinishOauthSignupModalContainerLoadable,
  ADD_EDIT_WORK_HISTORY_JOB: AddEditWorkHistoryJobModalContainerLoadable,
  DELETE_WORK_HISTORY_JOB: DeleteWorkHistoryJobModalContainerLoadable,
  ADD_EDIT_INTEGRATION: AddEditIntegrationModalContainerLoadable,
  AUTO_PUBLISH_INTEGRATION: AutoPublishIntegrationModalContainerLoadable,
  DELETE_INTEGRATION: DeleteIntegrationModalContainerLoadable,
  DUPLICATE_CONTENT: DuplicateContentModalContainerLoadable,
  DELETE_LOCATION_GROUP: DeleteLocationGroupModalContainerLoadable,
  DELETE_LOCATION: DeleteLandingPageLocationModalContainerLoadable,
  TITLE_DESCRIPTION: TitleDescriptionModalContainerLoadable,
  ORG_USER_PREFERENCES: OrgUserPreferencesModalLoadable,
};
type Ref = {
  current: null | HTMLElement;
};

function Modal({
  type,
  modalProps,
}: {
  type?: ModalType;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modalProps?: Record<string, any>;
}) {
  const [modalContext, setModalContext] = useState(null);
  const [focused, setFocused] = useState(false);
  const modalContainerRef: Ref = useRef(null);
  const isTabbing = useContext(TabContext);
  useEffect(() => {
    setFocused(false);
  }, [type]);
  useEffect(() => {
    if (!focused) {
      setFocused(true);

      if (type) {
        const modalContextElement = document.querySelector('*:focus');
        setModalContext(modalContextElement);
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '() => Element' is not assignable... Remove this comment to see the full error message
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line consistent-return
        waitForElement(() => {
          if (modalContainerRef && modalContainerRef.current) {
            const container = modalContainerRef.current;
            const els = Array.from(
              container.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
              )
            );

            if (isTabbing) {
              return (
                els.find((el) =>
                  el.matches(':not([data-modal-focus="false"])')
                ) || els[0]
              );
            }

            const firstFocusableElement =
              els.find((el) => el.matches('[data-modal-focus="true"]')) ||
              els.find((el) =>
                el.matches(':not([data-modal-focus="false"])')
              ) ||
              els[0];
            return firstFocusableElement;
          }
        }, 200)
          .then((el) => {
            el.focus();
          })
          .catch(() => {
            // do nothing
          });
      } else if (modalContext) {
        modalContext.focus();
        setModalContext(null);
      }
    }
  }, [type, modalContext, isTabbing, focused]);

  if (!type) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ModalComponent: any = MODAL_COMPONENTS[type];
  invariant(ModalComponent, `Invalid modal type: ${type}`);
  return (
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'Ref' is not assignable to type 'LegacyRef<HT... Remove this comment to see the full error message
    <div ref={modalContainerRef}>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <ModalComponent {...modalProps} />
    </div>
  );
}

type OwnProps = {
  type?: ModalType;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props?: Record<string, any>;
};

type Props = OwnProps & PropsFromRedux;

class UnconnectedModalRoot extends React.Component<Props> {
  componentDidCatch(
    error: Error,
    info: {
      componentStack: string;
    }
  ) {
    log.error(`stacktrace:\n${info.componentStack}`);

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.setError(error);
  }

  render() {
    const { props, type } = this.props;
    return <Modal type={type} modalProps={props} />;
  }
}

const connector = connect((state: MainStoreState) => state.modal, { setError });

type PropsFromRedux = ConnectedProps<typeof connector>;

export const ModalRoot = connector(UnconnectedModalRoot);
